import { Injectable } from '@angular/core';
import { ButtonColor } from '@shared/components/button/button.component';
import { Subject } from 'rxjs';

export interface AlertPayload {
    id?: string;
    title: string;
    text?: string;
    icon?: AlertIcon | null;
    cancelText?: string;
    confirmText?: string | null;
    confirmColor?: ButtonColor;
    showCloseButton?: boolean;
    timer?: number | 'default' | null;
    timerProgressBar?: boolean;
    showBackdrop?: boolean;
    backdropDismiss?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
    onClose?: () => void;

    // Web
    confirmButtonText?: any;
}

export type AlertIcon = 'success' | 'error' | 'loading' | 'warning' | 'info' | 'ultimate';

export interface AlertAction {
    action: 'close';
    id: string;
}

export interface AlertOptions {
    id?: string;
    title?: string;
    text?: string;
    icon?: AlertIcon;
    timer?: number | 'default';
    timerProgressBar?: boolean;
    allowOutsideClick?: boolean;
    showCloseButton?: boolean;
    confirmButtonText?: any;
    cancelButtonText?: any;
    showBackdrop?: boolean;
    didOpen?: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
}

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    $alerts: Subject<AlertPayload | null> = new Subject<AlertPayload | null>();
    $alertActions: Subject<AlertAction> = new Subject<AlertAction>();

    errorFromApi(
        err: any,
        timer: number | 'default' | undefined = undefined,
        showCloseButton: boolean | undefined = undefined
    ): void {
        let error = err;
        if (typeof err.getActualType === 'function' && err.getActualType() !== undefined) {
            error = err.getActualType().data.message;
        }
        this.createAlert({
            title: error,
            icon: 'error',
            timer,
            showCloseButton,
        });
    }

    closeAlertById(id: string): void {
        this.$alertActions.next({
            action: 'close',
            id,
        });
    }

    createAlert(options: AlertOptions): void {
        this.$alerts.next({
            id: options.id,
            title: options.title ?? '',
            text: options.text,
            icon: options.icon === undefined ? 'success' : options.icon,
            // cancelText: options.showCloseButton ? 'Close' : null,
            showCloseButton: options.showCloseButton,
            timer: options.timer === undefined ? 'default' : options.timer,
            timerProgressBar: options.timerProgressBar,
            showBackdrop: options.showBackdrop ?? true,
            backdropDismiss: options.allowOutsideClick ?? (options.timer === null ? false : true),
            confirmButtonText: options.confirmButtonText,
            cancelText: options.cancelButtonText,
            confirmText: options.confirmButtonText,
            onConfirm: options.onConfirm,
            onCancel: options.onCancel,
            onClose: options.onClose,
        });
    }

    showPrompt(title: string, icon: AlertIcon, timer: number | 'default' | null = null): void {
        this.$alerts.next({
            title,
            icon,
            confirmText: timer ? null : 'OK',
            timer,
            backdropDismiss: false,
        });
    }

    public clearAlerts(): void {
        this.$alerts.next(null);
    }
}
